module.exports = __webpack_public_path__ + "static/media/ca.0e73369d.png";